<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <router-link to="create-jobboard-spec" class="btn btn-info"
            >Create</router-link
          >
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <BTable id="company-table" :items="specs" :fields="fields">
              <div slot="table-busy" class="text-center my-2">
                <BSpinner class="align-middle"></BSpinner>
              </div>
              <template v-slot:cell(name)="data">
                <router-link
                  :to="{
                    name: 'update-jobboard-spec',
                    params: {
                      id: data.item.id
                    }
                  }"
                  >{{ data.item.name }}</router-link
                >
              </template>
            </BTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable, BSpinner } from "bootstrap-vue";

export default {
  components: {
    BTable,
    BSpinner
  },
  data() {
    return {
      isTableBusy: false,
      specs: [],
      fields: [
        { key: "name", label: "Name" },
        { key: "created_at", label: "Created At" }
      ]
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.isTableBusy = true;
      this.$http
        .get("/enroll_admin/jobboard-spec")
        .then(({ data }) => {
          this.specs = data;
        })
        .finally(() => (this.isTableBusy = false));
    }
  }
};
</script>
